<template>
    <div class="relative">
        <BaseButton
            class="text-theme-toolbar-icon"
            data-action="translate"
            :disabled="isOffline"
            :btn-text="btnText"
            :tooltip="localizations[lang].tooltips.translate"
            icon="translate-24px"
            @click="handleClick()"
        />
        <transition name="slide-fade">
            <ComponentTooltip v-show="showTooltipWarn" :allow-wrap="true">
                <div class="w-full text-center" style="white-space: pre-line">{{ errorMessage }}</div>
            </ComponentTooltip>
        </transition>
    </div>
</template>
<script>
import ComponentTooltip from '_shared_/UI/Components/ComponentTooltip.vue';
import BaseButton from '../../Components/buttons/BaseButton.vue';
import { mapState } from 'vuex';
import {
    TOOLTIP_AUTO_HIDE_DURATION,
    TRANSLATE_MAX_CHARACTERS,
} from '_shared_/js/constants/readerSelectionToolLimits.js';

export default {
    components: {
        ComponentTooltip,
        BaseButton,
    },
    props: {
        text: {
            type: String,
            required: true,
        },
        isDesktop: {
            type: Boolean,
            required: true,
        },
        openToast: {
            type: Function,
            required: true,
        },
        withText: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['translate'],
    data() {
        return {
            showTooltipWarn: false,
            maxCharacters: TRANSLATE_MAX_CHARACTERS,
        };
    },
    computed: {
        ...mapState(['localizations', 'lang', 'isOffline']),
        btnText() {
            return this.withText ? this.localizations[this.lang].tooltips.translate : null;
        },
        isValid() {
            const charCount = this.text?.length || 0;
            return charCount <= this.maxCharacters;
        },
        charCount() {
            return this.text?.length || 0;
        },
        errorMessage() {
            return this.localizations[this.lang].translateValidation.message
                .replace('{count}', this.charCount)
                .replace(/{max}/g, this.maxCharacters);
        },
    },
    methods: {
        handleClick() {
            if (!this.isValid) {
                if (!this.showTooltipWarn && this.isDesktop) {
                    this.showTooltipWarn = true;
                    setTimeout(() => (this.showTooltipWarn = false), TOOLTIP_AUTO_HIDE_DURATION);
                } else if (!this.isDesktop) {
                    this.openToast({ text: this.errorMessage });
                }
                return;
            }
            this.$emit('translate', this.text);
        },
    },
};
</script>
